import './ViewerCP.scss';
import React, {  useState, useEffect } from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import { default as _ } from '../../../helpers/Translate';
import {_loading} from "../../../actions/Loading";
import { useDispatch } from 'react-redux';
import LastModified from "../report/LastModified";
import {Viewer} from "@toast-ui/react-editor";
import snippets from "../../../helpers/snippets";
import {Link} from "react-router-dom";
import BaseApi from "../../../core/api/BaseApi";


const baseApi = new BaseApi()

export default function ViewerCP(props) {
    const dispatch = useDispatch();
    const [language] = useState(Storage.getLanguage())
    const [direction] = useState(Storage.directionGet())
    const [patientInfo, setPatientInfo] = useState()
    const [study, setStudy] = useState()
    const [reports, setReports] = useState([])


    useEffect(() => {
        if (props.data) {
            if (props.data?.reportID && props.data?.reportID !== "-1"){
                setReports([props.data?.study?.reports[props.data?.reportID]])
            } else {
                console.log(Object.values(props.data?.study?.reports).map(item => item))
                debugger
                setReports(Object.values(props.data?.study?.reports).map(item => item))
            }
            setPatientInfo(props.data.patient)
            setStudy(props.data.study)
        } else if (props.patientId) {
            let data = +props?.reportId
                ? {id: props.reportId, include_history: true}
                : {study_id: props.patientId}

            dispatch(_loading(true))
            baseApi.fullFetch("report", "get", {data: data}).then((response)=>{
                setPatientInfo(response.data.patient)
                setStudy(response.data.study)
                setReports([response.data.report])
            }).catch((error)=>{
                console.error(error)
            }).finally(()=>{
                dispatch(_loading(false))
            })
        }
    }, [props.patientId, props.data]);


    const reportFullDiv = (report, index) =>{
        return <div key={index} style={{width: "100%"}}>
            <div className={"report_viewer_component_report"}
                 style={{ direction: report?.direction, textAlign: report?.rtl ? "right" : "left"}}>
                <div className={`report_viewer_component_report_decriptionName ${report?.direction}`}>
                    {report?.description_name}
                </div>
                <div className={"report_viewer_component_report_findings "}>
                    <Viewer
                        key={report?.findings}
                        initialValue={report?.findings}
                        height='95%'
                        width='95%'
                    />
                </div>
                <div className={"report_viewer_component_report_devider"} />
                <div className={`report_viewer_component_report_impression ${report?.direction}`}>
                    <div dangerouslySetInnerHTML={{ __html: report?.impression}} />
                </div>
            </div>

            <div className={"report_viewer_component_ModifiedAndPrint"}>

                <LastModified report={report}/>

                <div className={"report_viewer_component_ModifiedAndPrint_spacer"} />

                {report?.can_print ?
                    <div className={"report_viewer_component_ModifiedAndPrint_print"}>
                        <Link className='print' target="_blank" rel="noreferrer" to={`/print/${study?.id}/${report?.id}`} replace={true} title={_.init("print", language)}>
                            <i className={'fal fa-print 2x'} />
                            <div>
                                <T token={"print_report"} />
                            </div>
                        </Link>
                    </div>

                    : null
                }
            </div>
        </div>
    }

    return (
        <div className={"report_viewer_component"} style={{direction: direction}}>
            <div className={"report_viewer_component_patientInfo"}>

                <div className='report_viewer_component_patientInfo_Item'>
                    <div className='report_viewer_component_patientInfo_Item_title'>
                        <T token={"full_name"} />:</div>
                    <div className='report_viewer_component_patientInfo_Item_info'>
                        <strong>{patientInfo?.his_or_original_full_name}</strong>
                    </div>
                </div>

                <div className={"report_viewer_component_patientInfo_devider"}>|</div>

                <div className='report_viewer_component_patientInfo_Item'>
                    <div className='report_viewer_component_patientInfo_Item_title'>
                        <T token={"patient_id"} />:</div>
                    <div className='report_viewer_component_patientInfo_Item_info'>
                        <strong>{_.syncNumberWithLanguage(patientInfo?.patient_code)}</strong></div>
                </div>

                <div className={"report_viewer_component_patientInfo_devider"}>|</div>

                <div className='report_viewer_component_patientInfo_Item'>
                    <div className='report_viewer_component_patientInfo_Item_title'>
                        <T token={"visit_time"} />:</div>
                    <div className='report_viewer_component_patientInfo_Item_info'>
                        {_.syncNumberWithLanguage(snippets.datetime(study?.date))}
                    </div>
                </div>

                <div className={"report_viewer_component_patientInfo_devider"}>|</div>

                <div className='report_viewer_component_patientInfo_Item'>
                    <div className='report_viewer_component_patientInfo_Item_title'>
                        <T token={'birth_date'} />{"("}<T token={'age'} />{")"}: </div>
                    <div className='report_viewer_component_patientInfo_Item_info'>
                        {_.syncNumberWithLanguage(snippets.datetime(patientInfo?.birth_date || patientInfo?.his_birth_date))}{`(${_.syncNumberWithLanguage(study?.age) })`}
                    </div>
                </div>
            </div>

            {reports?.map((item, index)=> reportFullDiv(item, index) )}

        </div>
    )
};

